












































import Vue from "vue";
import { Component, Inject } from "vue-property-decorator";
import { IUserModel } from "../models";
import { Getter } from "vuex-class";
import { LoginRoute } from "../router";
import { RestClient } from "@elite/restclient";
import { setAuthToken } from "../store";

@Component
export default class Navbar extends Vue {
    @Inject()
    restClient!: RestClient;

    @Getter
    user!: IUserModel;

    @Getter
    isAuthenticated!: boolean;

    @Getter
    isAdmin!: boolean;

    get userName(): string {
        if (this.user != null) {
            return this.user.firstName + " " + this.user.lastName;
        }

        return "";
    }

    async logout(): Promise<void> {
        setAuthToken(undefined);
        await this.$router.push(LoginRoute.path);
    }
}
